import React from 'react'

import history from 'history.js'

import LABEL from '../../../business-const/Label/Label'

import PATH from '../../../business-const/Path/Path'

import {
    ButtonPadrao,
} from '../../../business-components/Button/Button'

export const ButtonPadraoDashboardAporte = (props) => {

    return (
        <ButtonPadrao
            className="mt-0"
            label={LABEL.dashboardAporte}
            cor={1}
            onClick={() => {
                history.push(PATH.pageDashboardAporte)
            }}
            {...props}
        />
    )
}